import { CLIENT_LOGOS } from "@/data/clients";

export const ClientLogos = () => (
  <section className="border-b border-stone bg-ivory py-14 lg:py-16" aria-labelledby="client-logos-heading" data-testid="client-logos">
    <div className="wrap">
      <p id="client-logos-heading" className="text-center font-mono text-[11px] uppercase tracking-[0.22em] text-graphite">
        Trusted by manufacturers, service businesses and brands
      </p>
    </div>
    <div className="logo-marquee mt-10 overflow-hidden" data-testid="client-logo-slider">
      <ul className="logo-track flex w-max items-center gap-5 sm:gap-6">
        {[...CLIENT_LOGOS, ...CLIENT_LOGOS].map((src, i) => {
          const duplicate = i >= CLIENT_LOGOS.length;
          return (
            <li
              key={`${src}-${i}`}
              aria-hidden={duplicate ? "true" : undefined}
              className="flex h-24 w-[168px] shrink-0 items-center justify-center rounded-md border border-stone bg-white p-4 sm:w-[200px]"
            >
              <img
                src={src}
                alt={duplicate ? "" : "Client logo"}
                width="360"
                height="200"
                loading="lazy"
                decoding="async"
                className="max-h-full w-auto max-w-full object-contain"
              />
            </li>
          );
        })}
      </ul>
    </div>
  </section>
);
